
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/candidate/settings",
      function () {
        return require("private-next-pages/candidate/settings/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/candidate/settings"])
      });
    }
  